import { createContext, useContext } from 'react'

const InvoiceDataContext = createContext()

export const InvoiceDataProvider = InvoiceDataContext.Provider

export const useInvoicePageData = () => {
  const value = useContext(InvoiceDataContext)
  if (value === undefined) {
    throw new Error('useInvoicePageData must be used within an InvoiceDataProvider')
  }
  return value
}
